export const enum TransactionType {
  Spend = 0,
  Credit = 1,
}
